import styled from "styled-components";
import { tokens } from "../../../../public/tokens";

const { colors, typography, globals } = tokens;

export const StyledEmbeddedPdfInfo = styled.div({
    display: "flex",
    alignItems: "center",
    gap: globals["spacing-6"],
    padding: globals["spacing-3"],
    background: colors.ui.accent,
    border: `${globals["spacing-px"]} solid ${colors.ui.border}`,
    borderRadius: globals["border-radius"],
});

export const StyledEmbeddedPdfInfoContent = styled.div({
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: globals["spacing-2"],
    fontFamily: typography.fontFamilies["albert-sans"],
    fontSize: typography.fontSize["lg-14px"],
});

export const StyledEmbeddedPdfFieldCount = styled.div({
    fontWeight: typography.fontWeights.semibold,
    lineHeight: globals["spacing-4"],
    color: colors.text.primary,
});

export const StyledEmbeddedPdfDescription = styled.div({
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights["110"],
    color: colors.text.secondary,
});
